const TaiZi_1=[
    {
        "Contig_Num":"41208",
        "Contig_Len":"768118171",
        "GC":"38.79",
        "Scaffold_Num":"2054",
        "Scaffold_Len":"795122967",
        "Gap_Num":"39154",
        "Gap_Len":"27004796"
    }
]
export default TaiZi_1